import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/router";
import * as i3 from "../../shared/services/aviation-events.service";
import * as i4 from "../../shared/services/edit-toggle.service";
var EventResolver = /** @class */ (function () {
    function EventResolver(document, _router, _aviationEventsService, _errorHandler, _toggleService) {
        this.document = document;
        this._router = _router;
        this._aviationEventsService = _aviationEventsService;
        this._errorHandler = _errorHandler;
        this._toggleService = _toggleService;
    }
    EventResolver.prototype.resolve = function (route, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, aviationEvent, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        id = route.paramMap.get('id');
                        return [4 /*yield*/, this._aviationEventsService.getAviationEventById(+id)];
                    case 1:
                        aviationEvent = _a.sent();
                        this._toggleService.setState(false);
                        if (aviationEvent) {
                            return [2 /*return*/, aviationEvent];
                        }
                        this._router.navigate(['/404']);
                        return [2 /*return*/, null];
                    case 2:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        this._router.navigate(['/500']);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EventResolver.ngInjectableDef = i0.defineInjectable({ factory: function EventResolver_Factory() { return new EventResolver(i0.inject(i1.DOCUMENT), i0.inject(i2.Router), i0.inject(i3.AviationEventsService), i0.inject(i0.ErrorHandler), i0.inject(i4.EditToggleService)); }, token: EventResolver, providedIn: "root" });
    return EventResolver;
}());
export { EventResolver };
